import React, { useEffect, useState } from 'react'
import Cookie from 'cookie-universal'
import { ONE_WEEK } from '@mc/constants'
import { Checkbox } from '@mc/design-system'
import {
  getCheckboxState,
  NOT_VISIBLE_CHECKED,
  VISIBLE_UNCHECKED,
  VISIBLE_CHECKED,
} from '@mc/gdpr'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { EMAIL_CAPTURE_I18N } from '../constants'
import { i18nInstance } from '../i18n/i18nInstance'

const cookies = Cookie()

export const GdprCheckboxComp = ({
  className = '',
  containerClassName = 'mc-mb-4',
  label,
}: {
  className?: string
  containerClassName?: string
  label?: string
}) => {
  const { t } = useTranslation(EMAIL_CAPTURE_I18N)

  const [checked, setChecked] = useState<boolean>(
    getCheckboxState() === VISIBLE_CHECKED,
  )

  const handleInputChange = (check: boolean) => {
    cookies.set('gdpr_checked', check, { maxAge: ONE_WEEK })
    setChecked(check)
  }

  useEffect(() => {
    const isChecked = getCheckboxState() !== VISIBLE_UNCHECKED
    cookies.set('gdpr_checked', isChecked, { maxAge: ONE_WEEK })
  }, [])

  const checkboxState = getCheckboxState()

  const showGdpr = checkboxState && checkboxState !== NOT_VISIBLE_CHECKED

  return showGdpr ? (
    <div className={`${containerClassName} mc-form-group`}>
      <Checkbox
        name='gdpr'
        type='checkbox'
        checked={checked}
        onChange={handleInputChange}
        label={label || t('gdprCheckbox.label')}
        className={`${className} mc-text-small d-flex align-items-center`}
      />
    </div>
  ) : null
}

export const GdprCheckbox = withI18nContext(i18nInstance)(GdprCheckboxComp)
